import { render, staticRenderFns } from "./BaseContentBlock.vue?vue&type=template&id=411cd27b&scoped=true"
import script from "./BaseContentBlock.vue?vue&type=script&lang=js"
export * from "./BaseContentBlock.vue?vue&type=script&lang=js"
import style0 from "./BaseContentBlock.vue?vue&type=style&index=0&id=411cd27b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411cd27b",
  null
  
)

export default component.exports